import type { DirectoryAccessReason } from '@/hooks/use-business-directory-access';

export type DirectoryAccessKind =
  | 'allowed'
  | 'loading'
  | 'sign_in'
  | 'join_community'
  | 'pending_membership'
  | 'accept_invite'
  | 'disabled';

export function directoryAccessFromApiReason(
  reason: DirectoryAccessReason | undefined,
  canView: boolean | undefined
): DirectoryAccessKind {
  if (canView === true || reason === 'allowed') return 'allowed';
  if (!reason) return 'loading';
  switch (reason) {
    case 'sign_in':
      return 'sign_in';
    case 'pending':
      return 'pending_membership';
    case 'invited':
      return 'accept_invite';
    case 'join':
      return 'join_community';
    case 'disabled':
      return 'disabled';
    default:
      return 'join_community';
  }
}
